<template>
  <div>
    <!-- 新交易页面home -->
    <Header class="lognHeader" />
    <router-view id="v-content" class="router-view" :style="{minHeight: Height+'px'}" />
    <!-- <Footer class="footer lognFooter" /> -->
  </div>
</template>

<script>
import Header from '../base/header/Header'
// import Footer from '../base/footer/Footer'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    Header
    // Footer
  },
  data() {
    return {
      Height: 0
    }
  },
  computed: {
    ...mapGetters(['isIndexGetter'])
  },
  watch: {
    '$route'(to, from) {
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    // 动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 350
    // 监听浏览器窗口变化
    window.onresize = () => { this.Height = document.documentElement.clientHeight - 350 }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.header {
  width: 1920px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: transparent;
}
.footer {
  z-index: 999;

  /* top: 50px; */
  /* /* bottom: 0;  */
}
</style>
<style lang="scss">
.lognHeader {
  .sw{
    width: 100% !important;
    min-width: 1200px;
  }
}
.lognFooter{
  width: 100% !important
  // width: 1920px !important
}
</style>
